import { render, staticRenderFns } from "./q10.vue?vue&type=template&id=109a9f6e&scoped=true"
import script from "./q10.vue?vue&type=script&lang=js"
export * from "./q10.vue?vue&type=script&lang=js"
import style0 from "./q10.vue?vue&type=style&index=0&id=109a9f6e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109a9f6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('109a9f6e')) {
      api.createRecord('109a9f6e', component.options)
    } else {
      api.reload('109a9f6e', component.options)
    }
    module.hot.accept("./q10.vue?vue&type=template&id=109a9f6e&scoped=true", function () {
      api.rerender('109a9f6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/questionTemplates/q10.vue"
export default component.exports